import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {BehaviorSubject, Observable, throwError} from 'rxjs';
import {catchError, filter, finalize, switchMap, take} from 'rxjs/operators';
import {AuthServiceService} from './auth-service.service';
import {LoaderService} from "./other-services/loader.service";

// noinspection JSMethodCanBeStatic
@Injectable({
  providedIn: 'root'
})
export class InterceptorService implements HttpInterceptor {

  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  private requests: HttpRequest<any>[] = [];

  constructor(
    private router: Router,
    private authService: AuthServiceService,
    private loaderService: LoaderService
  ) {
  }

  removeRequest(req: HttpRequest<any>) {
    const i = this.requests.indexOf(req);
    if (i >= 0) {
      this.requests.splice(i, 1);
    }
    this.loaderService.isLoading.next(this.requests.length > 0);
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // console.log(request)
    this.requests.push(request);
    this.loaderService.isLoading.next(true);
    if (this.authService.getJwtToken()) {
      request = this.addToken(request, this.authService.getJwtToken());
    }
    return next.handle(request).pipe(
      catchError(error => {
        if (error instanceof HttpErrorResponse) {
          if (error.status === 401) {
            return this.handle401Error(request, next);
          } else if (error.status === 500) {
            this.loaderService.isLoading.next(false);
            return throwError("The backend was not able to handle this request. Please contact system admin 0781331616.");
          } else if (error.status === 0) {
            this.loaderService.isLoading.next(false);
            return throwError("This seems to be a network problem, please check your connection");
          } else if (error.status === 301) {
            this.loaderService.isLoading.next(false);
            return throwError(error?.error)
          } else {
            this.loaderService.isLoading.next(false);
            // console.log(error);
            return throwError(error?.error?.error?.message || "Something went wrong")
          }
        }
      }),
      finalize(() => {
        this.loaderService.isLoading.next(false);
      })
    ) as Observable<HttpEvent<any>>;
  }

  // tslint:disable-next-line: typedef
  private addToken(request: HttpRequest<any>, token: string): any {
    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  }

  private handle401Error(request: HttpRequest<any>, next: HttpHandler): any {
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);

      return this.authService.refreshToken().pipe(
        switchMap((token: any) => {
          this.isRefreshing = false;
          this.refreshTokenSubject.next(token.accessToken);
          return next.handle(this.addToken(request, token.accessToken));
        }));

    } else {
      return this.refreshTokenSubject.pipe(
        filter(token => token != null),
        take(1),
        switchMap(accessToken => {
          return next.handle(this.addToken(request, accessToken));
        }));
    }
  }

}
